import React from 'react';
import styles from './index.module.scss';

const Loader = ({ noBackground }) => {
  return (
    <section className={noBackground ? styles.loading : styles.loading_with_bg}>
      <div className={styles.circle}></div>
      <div className={styles.circle}></div>
      <div className={styles.circle}></div>
    </section>
  );
};

export default Loader;
